import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

import { Loading } from '../../SVG'

import CardBase from '../../cards/CardBase'
import { HibModal } from '../../HibModal'

import { MoneyFormate } from '../../MoneyFormate'
import WebServiceContext from "../../../webService/WebServiceContext";
import ListDataTable from "../ListDataTable";
import { BasicContext } from "../../../context/BasicContext";

type MeetingCheckProps = {
    //groupID:string
}

type MeetingCheckData = {
    //mdata: Manager.ManagerData[]
    MenuName: string
    TbData: string
}


const Content = (
    props: {
        cardName: string
        pdata: Manager.ProductProps[]
    }
) => {

    const [year, setYear] = useState<string>("")
    const [insName, setInsName] = useState<string>("")
    //const [open, setOpen] = useState<boolean>(false)
    const [rankList, setRankList] = useState<MixChart.DepDataProps[]>([])

    return (
        <>
            <CardBase
                collapseDisabled={true}
                collapseControl={true}
                title={props.cardName}
                type="MeetingCheck"
                children={
                    props.pdata.map((product: Manager.ProductProps, index: number) => {

                        //const row: MixChart.DepDataProps[] = JSON.parse(product.DepData) as MixChart.DepDataProps[]
                        return (
                            <button
                                onClick={() => {
                                    setYear(props.cardName)
                                    setInsName(product.InsName)
                                    setRankList(JSON.parse(product.DepData) as MixChart.DepDataProps[])
                                }}

                                className="hibBtn full"
                                key={"product" + index}
                            >
                                <span>
                                    No. {index + 1}
                                </span>
                                <span>
                                    {product.InsName}
                                </span>
                                <span >
                                    {product.OverPrd}
                                </span>


                            </button>
                        )
                    })

                }
            />
        </>
    )
}

export default (props: MeetingCheckProps) => {

    const bs = useContext(BasicContext)
    const ws = useContext(WebServiceContext)

    const [mdata, setMdata] = useState<MeetingCheckData[]>([])
    const [mdataStr, setMdataStr] = useState<string | null>(null)


    useEffect(() => {
        setMdata([])
        if( bs.SPType !="" && bs.SPGroupID !=""){
            ws.webservice.asyncManagerReader(bs.SPType, bs.SPGroupID, "%").then((res: any) => {
                const mcd: MeetingCheckData = res[0] as MeetingCheckData
                setMdata(JSON.parse(mcd.TbData))
            })
        }
    }, [bs.SPGroupID, bs.SPGroupID])

    return (
        <>
            {

                mdata.length > 0 ?
                    <CardBase
                        title=""
                        collapseDisabled={true}
                        collapseControl={true}
                        type=""
                        children={
                            <div className="tableBox meeting-check">
                                <ListDataTable
                                    className="meeting-check"
                                    dataStr={mdata}
                                />
                            </div>

                        }
                    />
                    :
                    <Loading />
            }
        </>)
}